<template>
  <div class="actionPlan">
    <div class="show add">
      <div class="head">
        <img src="~@img/xueyezixun/public/showTitle.png" alt="">
        <p>{{data.semester}}-{{data.name}}-{{data.actionPlan}}</p>
      </div>
      <div>
        <MessageTitle title="阶段任务考试" style="font-weight: normal"></MessageTitle>
        <circleName :name="'本阶段考试:'+data.semester+data.name"></circleName>
        <table>
          <tbody>
          <tr>
            <th style="width: 240px">科目</th>
            <th v-for="(item,index) in data.subject||[]" :key="index">{{item.subject}}</th>
          </tr>
          <tr>
            <td style="width: 240px">学期目标分数</td>
            <td v-for="(item,index) in data.subject||[]" :key="index">{{item.semesterTargetScore}}</td>
          </tr>
          <tr>
            <td style="width: 240px">学期名次目标</td>
            <td v-for="(item,index) in data.subject||[]" :key="index">{{item.semesterRankingGoals}}</td>
          </tr>
          <tr>
            <td style="width: 240px">阶段分数目标</td>
            <td v-for="(item,index) in data.subject||[]" :key="index">{{item.stageScoreGoal}}</td>
          </tr>
          <tr>
            <td style="width: 240px">阶段名次目标</td>
            <td v-for="(item,index) in data.subject||[]" :key="index">{{item.stageRankingGoal}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <ul class="showlist">
        <li v-for="(item,index) in data.subjectStress||[]" :key="index">
        <span>
          <img src="~@img/xueyezixun/public/star.png" alt="">
          {{index}}
        </span>
          <div v-for="(it,i) in item" :key="i">
            <p>阶段问题{{it.length>1?i+1:''}}:{{it.stageProblem}}</p>
            <p>阶段任务{{it.length>1?i+1:''}}:{{it.stageTask}}</p>
          </div>
        </li>
        <li v-for="(item,index) in data.subjectCommon||[]" :key="index">
        <span>
          <img src="~@img/xueyezixun/public/star.png" alt="">
          {{index}}
        </span>
          <div v-for="(it,i) in item" :key="i">
            <p>阶段问题{{it.length>1?i+1:''}}:{{it.stageProblem}}</p>
            <p>阶段任务{{it.length>1?i+1:''}}:{{it.stageTask}}</p>
          </div>
        </li>
      </ul>
      <div>
        <MessageTitle title="学习习惯养成" style="font-weight: normal"></MessageTitle>
        <div class="habit">
          <table v-for="(item,index) in data.subjectLearnHabit||[]" :key="index">
            <tbody>
            <tr>
              <th colspan="2"></th>
            </tr>
            <tr>
              <td>阶段问题</td>
              <td>{{item.stageProblem}}</td>
            </tr>
            <tr>
              <td>目标习惯</td>
              <td>{{item.targetHabit}}</td>
            </tr>
            <tr>
              <td>行动方案</td>
              <td>{{item.actionPlan}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div>
        <MessageTitle title="路径条件" style="font-weight: normal"></MessageTitle>
        <circleName :name="'条件目标：'+data.consultRecord"></circleName>
        <div class="habit">
          <table v-for="(item,index) in data.subjectPathCondition||[]" :key="index">
            <tbody>
            <tr>
              <th colspan="2"></th>
            </tr>
            <tr>
              <td>阶段目标</td>
              <td>{{item.stageTarget}}</td>
            </tr>
            <tr>
              <td>阶段任务</td>
              <td>{{item.stageTask}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div style="text-align: center;margin:40px 0">
        <Button name="返回" @handleClick="$router.back()"></Button>
      </div>
    </div>
  </div>
</template>
<script>
import MessageTitle from '@/components/xueyezixun/MessageTitle.vue'
import CircleName from "@/components/xueyezixun/CircleName";
import SummaryTitle from "@/components/xueyezixun/SummaryTitle";
import Button from "@/components/xueyezixun/Button";
import GradeDetail from './gradeDetail'
export default {
  name: 'gradeDetail',
  components:{MessageTitle ,CircleName,SummaryTitle,Button,GradeDetail },
  data() {
    return {
      data:{

      }
    }
  },
  methods: {
    getData(){
      this.$ajax.post(this.G_acapi+ this.ports.parent.student.implement.getActionPlanDetailByParent, {
        id:this.$route.query.actionPlanId
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          this.data=res.data.data
        }else{

        }
      })
    },
  },
  mounted() {
    this.getData()
  }
}
</script>
<style scoped lang="less">
    th{
      font-weight: bolder;
      text-align: center;
      color:#5C5C5C;
    }
  @import "./css/index.less";
</style>